// Titles
export const APP_TITLE = 'Powersensor admin';
export const LOGIN_PAGE = 'Login';
export const RECENT_INSTALLATIONS_PAGE = 'Recent installations';
export const LOGOUT_PAGE = 'Logging out';
